import * as actionTypes from './actionTypes';
import { adsRepublishService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidate } from '@app/src/common/session';

const fetchAdsRepublishRequest = () => ({
  type: actionTypes.FETCH_ADS_REPUBLISH_REQUEST
});

const fetchAdsRepublishSuccess = (data) => ({
  type: actionTypes.FETCH_ADS_REPUBLISH_SUCCESS,
  data
});

const fetchAdsRepublishFailure = () => ({
  type: actionTypes.FETCH_ADS_REPUBLISH_FAILURE
});

export const clearAdsRepublishData = () => ({
  type: actionTypes.CLEAR_ADS_REPUBLISH_DATA
});

export const fetchAdsRepublish = (userId, categoryId, uniqueId): Function => {
  return async dispatch => {
    dispatch(fetchAdsRepublishRequest());
    await dispatch(fetchValidate());
    try {
      const data = await adsRepublishService.getPrint(userId, categoryId, uniqueId);
      dispatch(fetchAdsRepublishSuccess(data && data[0]));
    } catch (e) {
      dispatch(fetchAdsRepublishFailure());
      dispatch(actionsModalError.openModalError());
      console.log(`Error action fetchAdsRepublish: ${e}`);
    }
  }
};

export const fetchAdsRepublishWeb = (webId: number): Function => {
  return async dispatch => {
    dispatch(fetchAdsRepublishRequest());
    try {
      const data = await adsRepublishService.getWeb(webId);
      dispatch(fetchAdsRepublishSuccess(data && data[0]));
    } catch (e) {
      dispatch(fetchAdsRepublishFailure());
      dispatch(actionsModalError.openModalError());
      console.log(`Error action fetchAdsRepublishWeb: ${e}`);
    }
  }
};
